import React, {
    useState,
    // useEffect 
} from 'react';

// import { makeStyles } from '@material-ui/core/styles';
// import FormHelperText from '@material-ui/core/FormHelperText';
// import FormControl from '@material-ui/core/FormControl';
// import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
// import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import Styles from '../Styles'

import { api_bd } from '../../services/Api'

import { useRecoilState, useRecoilValue } from 'recoil'
import clientDetailsData from '../../atoms/client_details.atom'

function FormDataTransit(props) {
    const { data_client, width, data_client_update } = props
    const styles = Styles();

    const [data_transit, set_data_transit] = useState({})
    const [submit_is_disabled, set_submit_is_disabled] = useState(false)

    const [update_client_data, set_update_client_data] = useRecoilState(clientDetailsData)

    // useEffect(() => {
    //     console.log('Dados Transito: ', data_transit)
    // }, [data_transit])

    const handle_data_transit = (key, value) => {
        let data = data_transit
        data[key] = value
        set_data_transit(data)
    }



    return (
        <div className={styles.div_root_component} style={{ width }}>
            <Card className={styles.card} >
                <CardContent>
                    <CardHeader
                        title="Adicionar Trânsito"
                        subheader=""
                    />
                    <form className={styles.form_cad_user} noValidate autoComplete="off">
                        <div style={{width: "100%"}}>
                            <TextField
                                className={styles.form_input}
                                onChange={e => {
                                    handle_data_transit("descricao", e.target.value)
                                }}
                                id="descricao"
                                label="Descrição"
                                required={true}
                            />
                        </div>
                        <div style={{width: "100%"}}>
                            <TextField
                                className={styles.form_input}
                                onChange={e => {
                                    handle_data_transit("servico", e.target.value)
                                }}
                                id="servico"
                                label="Serviço"
                                required={true}
                            />
                        </div>
                        <div style={{width: "100%"}}>
                            <TextField
                                className={styles.form_input}
                                onChange={e => {
                                    handle_data_transit("ip", e.target.value)
                                }}
                                id="ip"
                                label="IP"
                                required={true}
                            />
                        </div>
                        <div style={{width: "100%"}}>
                            <TextField
                                className={styles.form_input}
                                onChange={e => {
                                    handle_data_transit("banda", e.target.value)
                                }}
                                id="banda"
                                label="Banda"
                                required={true}
                            />
                        </div>
                        <div style={{width: "100%"}}>
                            <Button
                                className={styles.btn_submit}
                                variant="contained"
                                color="primary"
                                size="small"
                                disabled={submit_is_disabled}
                                onClick={async () => {
                                    
                                    const filters = {
                                        descricao: "Descrição", 
                                        servico: "Serviço", 
                                        ip: "IP",
                                        banda: "Banda"
                                    }
    
                                    for(let f in Object.values(filters)){
                                        let filter = Object.keys(filters)[f]
                                        if(data_transit[filter] === undefined || data_transit[filter] === ''){
                                            return alert(`Campo obrigatório: ${filters[filter].toUpperCase()}`)
                                        }
                                    }


                                    try {
                                        const resp = await api_bd.put(`/customers/addtransit/${data_client._id}`, data_transit)
                                        // data_client_update(resp.data)
                                        // alert(`Dados inseridos com sucesso!\nTRÂNSITO\nDescrição: ${data_transit.descricao}\nCliente: ${data_client.nome}`)
                                        props.callbackfn()
                                        set_update_client_data(resp.data)
                                    } catch (error) {
                                        if (error.message.indexOf('code 400') > -1) {
                                            alert("Verifique os dados e tente novamente.")
                                        }
                                    }
                                    // console.log('Dados Transito: ', JSON.stringify(data_transit))
                                }}
                            >
                                Salvar
                        </Button>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}

export default FormDataTransit;

//Schema Transito
//{"descricao":"Descricao transito","servico":"servico","banda":"3GB"}